import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store'
import util from '@/libs/util.js'
import common from '@/pages/common/router'
import account from '@/pages/account/router'

// 路由数据
const frameInRoutes = require('@/project/routes.js')

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: 'history',
  routes: [
    ...frameInRoutes.default,
    ...account,
    ...common
  ]
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  if (store.getters['system/common/routes'].length <= 0) {
    store.dispatch('system/common/loadHostConfig').then(config => {
      const plugins = config.plugins
      store.dispatch('system/common/buildRoutes', plugins).then(routes => {
        // console.log(JSON.stringify(routes))
        router.addRoutes(routes)
      })
    })
  }

  store.commit('system/common/setRoute', to)
  // if (to.matched.length === 0) {
  //   next({ path: '/404' })
  //   return
  // }
  NProgress.start()
  store.commit('d2admin/search/set', false)
  let transition = true
  if (to.meta.transition === false) {
    transition = false
  }
  store.commit('d2admin/transition/set', transition)
  if (to.matched.some(r => r.meta.auth)) {
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      next()
    } else {
      const open = util.cookies.get('open-client')
      if (open) {
        next({
          name: 'info',
          query: { redirect: to.fullPath }
        })
      } else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        })
      }
      NProgress.done()
    }
  } else {
    next()
  }
})

router.afterEach(to => {
  NProgress.done()
  store.dispatch('d2admin/page/open', to)
  util.title(to.meta.title, store.state.system.common.currentHost)
})

export default router
